import React from "react";

const PosterGuideCard = ({ label, value, sub }) => {
  return (
    <div className="group border-b border-slate-100 dark:border-slate-800 pb-6 transition-all hover:border-blue-500">
      <p className="text-[9px] font-black uppercase text-blue-600 dark:text-blue-400 mb-2 tracking-[0.2em]">
        {label}
      </p>
      <p className="text-xl font-bold text-slate-900 dark:text-white group-hover:text-blue-600 transition-colors">
        {value}
      </p>
      <p className="text-xs text-slate-500 dark:text-slate-400 font-medium mt-1">
        {sub}
      </p>
    </div>
  );
};

export default PosterGuideCard;